<template>
  <ul class="pb-tag-breadcrumb">
    <TagBreadcrumbItem
      v-for="parent in tag.parents"
      :key="parent.path"
      :tag="parent"
      :link="routeName"
    />
    <TagBreadcrumbItem
      :tag="tag"
    />
  </ul>
</template>

<script setup>
import TagBreadcrumbItem from '@/components/TagBreadcrumbItem.vue'

defineProps({
  routeName: { type: String, required: true },
  tag: { type: Object, default: () => ({}) },
})
</script>

<style lang="scss">
.pb-tag-breadcrumb-item {
  list-style-type: none;
  display: inline;

  &:before {
    content: '/';
    padding: 0 5px;
  }

  &:first-of-type {
    &:before {
      display: none;
    }
  }
}
</style>
